import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import { BookingsSettings } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { shouldOpenPreferencesModal as shouldOpenPreferencesModalUtil } from '@wix/bookings-services-preferences-modal/utils';
import Experiments from '@wix/wix-experiments';
import { IWixAPI } from '@wix/yoshi-flow-editor';

export interface BookButtonViewModel {
  isPendingApprovalFlow?: boolean;
  navigationInitiatedBy?: string;
  shouldOpenServicesPreferencesModal?: boolean;
}

export const bookButtonViewModelFactory = (
  service: Service,
  experiments: Experiments,
  wixCodeApi: IWixAPI,
  bookingsSettings?: BookingsSettings,
): BookButtonViewModel => {
  let shouldOpenServicesPreferencesModal = false;

  if (bookingsSettings) {
    shouldOpenServicesPreferencesModal = shouldOpenPreferencesModalUtil({
      service,
      bookingsSettings,
      experiments,
      queryParams: wixCodeApi.location.query || {},
    });
  }

  return {
    isPendingApprovalFlow: service?.onlineBooking?.requireManualApproval!,
    shouldOpenServicesPreferencesModal,
  };
};
